import axios from 'axios';
import { cleanAndRedirect } from './query';

const run = axios.create({
  baseURL: 'https://hg3.justwithu.com/api/',
});

/* The `run.interceptors.request.use()` function is an interceptor for handling requests made by the
Axios HTTP client. It takes a callback function as an argument, which is executed before the request
is sent. */
run.interceptors.request.use((config) => {
  const getAccessToken = localStorage.getItem('accessToken');
  if (typeof getAccessToken === 'string') {
    const convertedAccessToken = JSON.parse(getAccessToken);
    config.headers.Authorization = `Bearer ${convertedAccessToken.access_token}`;
  }
  return config;
});

/* The `run.interceptors.response.use()` function is an interceptor for handling responses from the
Axios HTTP client. It takes two callback functions as arguments: one for handling successful
responses (`response => response`) and one for handling errors (`error => {...}`). */
run.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.code === 'ERR_NETWORK') {
     error.response.data.error =
        'خطایی در شبکه رخ داده است. لطفا اینترنت خود را بررسی کنید در صورت تکرار اگر پروکسی یا وی پی ان روشن دارید آن را خاموش نمایید';
    }

    if (error?.response?.status === 401) {
      cleanAndRedirect();
    }
    if (error?.response?.status === 500) {
     error.response.data.error =
        "خطای پیش بینی نشده رخ داده است یا اختلالی در اینترنت شما وجود دارد. درصورت تکرار با پشتیبانی در تماس باشید.";
    }
    return Promise.reject(error);
  }
);

export default run;
